import { useState } from "react";
import { BellRing, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../api";

export const NotifyForm = () => {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/subscribers", { email });
      setDone(true);
      toast.success("You're on the launch list!");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(
        typeof detail === "string" ? detail : "Please enter a valid email address"
      );
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div
        data-testid="notify-success"
        className="mt-8 inline-flex items-center gap-3 px-7 py-4 rounded-2xl bg-mint border-2 border-ink font-display font-extrabold text-lg text-ink"
      >
        <Check size={22} /> You're in! We'll email you at launch.
      </div>
    );
  }

  return (
    <form
      onSubmit={submit}
      data-testid="notify-form"
      className="mt-8 flex flex-col sm:flex-row gap-3 max-w-lg mx-auto"
    >
      <input
        type="email"
        required
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        data-testid="notify-email-input"
        placeholder="you@example.com"
        className="flex-1 px-5 py-4 rounded-2xl border-2 border-ink bg-white font-medium focus:outline-none focus:ring-2 focus:ring-coral"
      />
      <button
        type="submit"
        disabled={loading}
        data-testid="notify-submit-button"
        className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-2xl bg-ink text-cream font-display font-extrabold text-lg border-2 border-ink shadow-brutal-sm hover:-translate-y-1 hover:shadow-brutal hover:bg-coral transition-all duration-200 disabled:opacity-60"
      >
        <BellRing size={18} /> {loading ? "Joining…" : "Notify me"}
      </button>
    </form>
  );
};
